import { FileManagerInput, CustomAutocomplete } from 'common'
import { Button, Chip, FormControl, Grid, TextField } from "@mui/material"
import { DownloadChip } from 'common/DownloadChip/DownloadChip'
import { DownloadCloud, Eye } from 'react-feather'



const acceptConfiguration = {
    'image/jpeg': ['.jpeg', '.jpg'],
    'image/png': ['.png'],
    'image/webp': ['.webp']
}

const ModalFormDeposit = ({useFetchInit}) => {

 
    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        FetchData,

        defaultData,
        
        //------------- Actions
        Actions
    } = useFetchInit


    const {modalOpeningMode} = globalStates

    const {handleClickDownloadImage} = Actions

    const { FormDeposit } = Forms
    const { formState, onInputChange, onSelectSearchChange, onDropZoneAcceptedFilesChange, onDropZoneRejectionsFilesChange } = FormDeposit

    const {fetchAllBanks} = FetchData
    const {banks} = fetchAllBanks

    return (
        <div className='content'>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ marginBottom: 2, marginTop: 2 }}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <FormControl fullWidth> 
                        <label htmlFor="boleta_numero">* Numero de Boleta</label>
                        <TextField
                            id='boleta_numero'
                            name='boleta_numero'
                            value={ formState.boleta_numero }
                            onChange={ onInputChange }
                            size="small"
                            hiddenLabel
                            placeholder='Numero de Boleta'
                            type='number'
                            variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                            InputProps={{
                                readOnly: (modalOpeningMode === 'READONLY') ? true : false
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>   
                    <FormControl fullWidth>
                        <label htmlFor="idbanco">* Banco</label>
                        <CustomAutocomplete 
                                customId="idbanco"
                                customName="idbanco"
                                customValue={formState.idbanco}
                                customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idbanco', value: value.value }})}
                                customPlaceholder='Seleccionar banco'
                                customOptions={
                                    banks.map(({ idbanco, nombre }) => ({
                                        value: idbanco,
                                        name: nombre
                                    }))
                                }
                                customDisableClearable={true}
                                customDisabled={(modalOpeningMode==='READONLY') ? true : false}
                        />
                    </FormControl>
                </Grid>
            </Grid>
                {(modalOpeningMode==='EDITABLE')&&(
                    <Grid item xs={12} sm={12} md={12} lg={12}>   
                        <FormControl fullWidth>
                            <label htmlFor="images">* Boleta de Deposito</label>
                            <FileManagerInput
                                acceptedFiles={formState.acceptedFiles}
                                fileRejections={formState.fileRejections}
                                NameId='images'
                                typeFiles='IMG'
                                maxFiles={1}
                                accept={acceptConfiguration}
                                setAcceptedFiles={onDropZoneAcceptedFilesChange}
                                setFileRejections={onDropZoneRejectionsFilesChange}
                            />
                        </FormControl>
                    </Grid>
                )}

                {(modalOpeningMode==='READONLY')&&(
                    <>
                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ marginBottom: 2, marginTop: 2 }}>
                        <Grid item xs={12} sm={12} md={2} lg={2}>   
                        <FormControl fullWidth>
                            <label htmlFor="dowload-boleta">* Boleta de Deposito</label>
                            <Button
                                startIcon={<DownloadCloud/>}
                                color='success'
                                variant="contained"
                                onClick={(event) => handleClickDownloadImage( formState.boleta_foto_originalname, formState.boleta_foto_path )}
                                sx={{textDecoration: 'none', paddingTop: 1}}
                            >Descargar</Button>
                        </FormControl>
                        </Grid>   
                        <Grid item xs={12} sm={12} md={5} lg={5}>
                            <FormControl fullWidth>
                            <label htmlFor="boleta">* No. Referencia ACH</label>
                                <TextField
                                    id='aprobacion_referencia_ach'
                                    name='aprobacion_referencia_ach'
                                    value={ formState.aprobacion_referencia_ach }
                                    onChange={ onInputChange }
                                    size="small"
                                    hiddenLabel
                                    placeholder='No. Referencia ACH'
                                    type='number'
                                    variant= 'outlined'
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    required
                                />   
                            </FormControl>
                        </Grid>   
                        <Grid item xs={12} sm={12} md={5} lg={5}>   
                        <FormControl fullWidth>
                            <label htmlFor="boleta">* Aprobacion</label>
                            <CustomAutocomplete 
                                customId="aprobacion_check"
                                customName="aprobacion_check"
                                customValue={formState.aprobacion_check}
                                customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'aprobacion_check', value: value.value }})}
                                customPlaceholder='Seleccionar un modo'
                                customOptions={
                                    defaultData.optionsAprobacionDeposit.map(({ value, label }) => ({
                                        value: value,
                                        name: label
                                    }))
                                }
                                customDisableClearable={true}
                                customDisabled = {true}
                            />
                        </FormControl>
                        </Grid>     
                    </Grid>
                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ marginBottom: 2, marginTop: 2 }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>   
                            <FormControl fullWidth>
                            <label htmlFor="aprobacion_observaciones">Observaciones</label>
                                <TextField
                                    id='aprobacion_observaciones'
                                    name='aprobacion_observaciones'
                                    value={ formState.aprobacion_observaciones }
                                    onChange={ onInputChange }
                                    size="small"
                                    multiline
                                    rows={5}
                                    hiddenLabel
                                    placeholder='Observaciones'
                                    type='text'
                                    variant= 'outlined'
                                    InputProps={{
                                        readOnly: true
                                    }}
                                />   
                            </FormControl>
                        </Grid>   
                    </Grid>
                    </> 
                )}
        </div>

    )
}

export{
    ModalFormDeposit
}